module.exports = TalendDesignSystem;